var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 48C39.0457 48 48 39.0457 48 28C48 16.9543 39.0457 8 28 8C16.9543 8 8 16.9543 8 28C8 39.0457 16.9543 48 28 48ZM28 49C39.598 49 49 39.598 49 28C49 16.402 39.598 7 28 7C16.402 7 7 16.402 7 28C7 39.598 16.402 49 28 49Z",
    fill: "#2C666E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 14H11C9.34315 14 8 15.3431 8 17V39C8 40.6569 9.34315 42 11 42H45C46.6569 42 48 40.6569 48 39V17C48 15.3431 46.6569 14 45 14ZM11 13C8.79086 13 7 14.7909 7 17V39C7 41.2091 8.79086 43 11 43H45C47.2091 43 49 41.2091 49 39V17C49 14.7909 47.2091 13 45 13H11Z",
    fill: "#2C666E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 45V11C42 9.34315 40.6569 8 39 8L17 8C15.3431 8 14 9.34315 14 11L14 45C14 46.6569 15.3431 48 17 48H39C40.6569 48 42 46.6569 42 45ZM43 11C43 8.79086 41.2091 7 39 7L17 7C14.7909 7 13 8.79086 13 11L13 45C13 47.2091 14.7909 49 17 49H39C41.2091 49 43 47.2091 43 45V11Z",
    fill: "#2C666E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/design.600a687d09d18a39d3fbb60ccff49e49.svg";
export { ForwardRef as ReactComponent };